// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton_backButton__PqcxW","arrowIcon":"BackButton_arrowIcon__2mFGj","backButtonLabel":"BackButton_backButtonLabel__ljnYH"};